module.exports = __webpack_public_path__ + "static/hv-investments-logo-039efd5da3a3977ffd127f9dda3ffae5.jpg";